import { OnInit, ElementRef, } from "@angular/core";
import { resolveThemeCssClass } from "../lib/helper/panel-settings";
import { applySubtitleSettings, applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
var CardGridPanelComponent = /** @class */ (function () {
    function CardGridPanelComponent() {
        this.scrollPosition = null;
    }
    Object.defineProperty(CardGridPanelComponent.prototype, "hostClasses", {
        get: function () {
            return resolveThemeCssClass(this.data.panelSettings);
        },
        enumerable: true,
        configurable: true
    });
    CardGridPanelComponent.prototype.onWindowScroll = function () {
        this.scrollPosition = window.pageYOffset;
        if (this.scrollPosition + window.outerHeight >
            this.panelElRef.nativeElement.offsetTop) {
            this.loadMedia();
        }
    };
    CardGridPanelComponent.prototype.ngOnInit = function () {
        this.scrollPosition = window.pageYOffset;
    };
    CardGridPanelComponent.prototype.ngAfterViewInit = function () {
        this.applyCustomStyling();
        this.applyCardStyles();
        if (this.scrollPosition + window.outerHeight >
            this.panelElRef.nativeElement.offsetTop) {
            this.loadMedia();
        }
    };
    CardGridPanelComponent.prototype.loadMedia = function () {
        if (this.data &&
            this.data.backgroundImage &&
            this.data.backgroundImage.value &&
            this.panelElRef &&
            this.panelElRef.nativeElement) {
            this.panelElRef.nativeElement.style.backgroundImage =
                "url(" + this.data.backgroundImage.value.src + ")";
            this.panelElRef.nativeElement.style.backgroundSize = "cover";
            this.panelElRef.nativeElement.style.backgroundRepeat = "no-repeat";
        }
    };
    CardGridPanelComponent.prototype.applyCustomStyling = function () {
        var _this = this;
        if (this.data &&
            this.data.capitalizeTitle &&
            this.data.capitalizeTitle.value) {
            this.data.capitalizeTitle.value.forEach(function (item) {
                switch (item) {
                    case "Title":
                        if (_this.titleEl && _this.titleEl.nativeElement)
                            _this.titleEl.nativeElement.style.textTransform = "uppercase";
                        break;
                    case "Subtitle":
                        if (_this.subtitleEl && _this.subtitleEl.nativeElement)
                            _this.subtitleEl.nativeElement.style.textTransform = "uppercase";
                        break;
                }
            });
        }
        applyTitleSettings(this.data, this.titleEl);
        applySubtitleSettings(this.data, this.subtitleEl);
    };
    CardGridPanelComponent.prototype.applyCardStyles = function () {
        var _this = this;
        if (this.data.items.value && this.cardsEl) {
            this.cardsEl.forEach(function (item, i) {
                var currentElem = _this.data.items.value[i];
                if (currentElem.titleColor && currentElem.titleColor.value) {
                    item.nativeElement.style.setProperty("--item-title-color", currentElem.titleColor.value);
                }
                else {
                    item.nativeElement.style.setProperty("--item-title-color", "#" + _this.data.cardFontColorPicker.value);
                }
                if (currentElem.titleFontWeight && currentElem.titleFontWeight.value) {
                    item.nativeElement.style.setProperty("--item-title-font-weight", currentElem.titleFontWeight.value);
                }
                if (currentElem.titleSize && currentElem.titleSize.value) {
                    item.nativeElement.style.setProperty("--item-title-size", currentElem.titleSize.value + 'px');
                }
                if (currentElem.backgroundColor && currentElem.backgroundColor.value) {
                    item.nativeElement.style.setProperty("--item-background-color", currentElem.backgroundColor.value);
                }
                else {
                    item.nativeElement.style.setProperty("--item-background-color", "#" + _this.data.cardColorPicker.value);
                }
                if (!currentElem.rteStyleSettings ||
                    !currentElem.rteStyleSettings.textColor ||
                    !currentElem.rteStyleSettings.textColor.value) {
                    item.nativeElement.style.setProperty("--item-description-color", "#" + _this.data.cardFontColorPicker.value);
                }
                if (currentElem.cornerRadius && currentElem.cornerRadius.value) {
                    item.nativeElement.style.setProperty("--item-corner-radius", currentElem.cornerRadius.value + "px");
                }
                applyRteSettings(currentElem, item);
            });
        }
    };
    return CardGridPanelComponent;
}());
export { CardGridPanelComponent };
